<script lang="ts">
  let { text }: { text?: string } = $props();
</script>

<oc-skip-link-v1>
  <oc-button-v1 variant="secondary" size={/*      */ "50"} icon-type-left="skip-link">
    {text} überspringen
  </oc-button-v1>
</oc-skip-link-v1>
